<template>
  <div id="project" v-if="project">
    <!-- <lines/> -->
    <transition name="project" mode="in-out">
      <div class="project__wrapper">
        <div class="project__content">
          <div class="project__title">
            <h2>
              <overflow-transition class="title" :text="project.title" :line-height="52"/>
            </h2>
            <div class="title__sub">
              <slide-transition :line-height="16" color="#FA8A66">
                <p>{{project.subtitle}}</p>
              </slide-transition>
            </div>
          </div>
          <div class="project__infos">
            <ul class="infos__list">
              <li>
                <div class="list__title">
                  year
                </div>
                <div class="list__value">
                  <overflow-transition :text="project.year" :line-height="18"/>
                </div>
              </li>
              <li>
                <div class="list__title">role</div>
                <div class="list__value">
                  <overflow-transition :text="project.role" :line-height="18"/>
                </div>
              </li>
            </ul>
            <div class="description">
              <slide-transition :line-height="22" color="#ececec" :rows="3">
                <span>{{project.description}}</span>
              </slide-transition>
            </div>
            <a v-if="project.url" :href="project.url" target="_blank">
              see live
            </a>
          </div>
        </div>
        <div class="project__image">
          <slide-transition :line-height="400" color="#FA8A66">
            <div class="img" :style="{'background-image' : `url(${image})`}"></div>
          </slide-transition>
        </div>
      </div>
    </transition>
    <navigation/>
    <nav-switcher/>
    <nav-points :current="project"/>
  </div>
</template>

<script>

import Lines from '@/components/Lines'
import Navigation from '@/components/Nav'
import NavSwitcher from '@/components/NavSwitcher'
import NavPoints from '@/components/NavPoints'
import SlideTransition from '@/components/SlideTransition.vue'
import OverflowTransition from '@/components/OverflowTransition.vue'

import projects from '@/json/projects'

import {mapState} from 'vuex'
import {Lethargy} from 'lethargy';

export default {
  name: 'Project',
  components: {
    Navigation,
    NavSwitcher,
    NavPoints,
    Lines,
    SlideTransition,
    OverflowTransition
  },
  watch: {
    '$route' (to, from) {
      this.$store.dispatch('getProject', to.params.project)
      this.image = require(`@/assets/images/projects/${this.project.slug}.jpg`)
    },
  },
  data() {
    return{
      image: null,
      urls: [],
      lethargy: null,
      wait: false,
    }
  },
  computed: {
    ...mapState({
      project: state => state.projects.project
    })
  },
  async mounted() {
    this.lethargy = new Lethargy();
    const project = await this.$store.dispatch('getProject', this.$route.params.project)

    this.image = require(`@/assets/images/projects/${this.project.slug}.jpg`)

    projects.forEach(project => {
      this.urls.push(require(`@/assets/images/projects/${project.slug}.jpg`))
      this.urls.push(require(`@/assets/images/projects/bg/${project.slug}.jpg`))
    })
    
    window.addEventListener('wheel', this.onMouseWheel);
  },
  destroyed() {
    window.removeEventListener('wheel', this.onMouseWheel);
  },
  beforeRouteUpdate(to, from, next) {
    setTimeout(() => {
      this.wait = false;
    }, 1250);

    next();
  },
  methods: {
    onMouseWheel(e) {
      const check = this.lethargy.check(e);
      if(check !== false && !this.wait ) {
        this.wait = true;

        const current = projects.findIndex(p => p.slug === this.project.slug);
        let next = current + check;

        next = next === projects.length ? 0 : next;
        next = next === -1 ? projects.length - 1 : next;

        this.$router.push(`/${projects[next].slug}`)
      } 
    }
  }
}
</script>

<style lang="scss">
#project{
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  transform: scaleX(0);
}

.project__wrapper{
  position: relative;
  z-index: 10;
  width: 100%;
  flex-shrink: 0;
  height: auto;
  display: flex;
  flex-direction: row;
}
.project__content{
  display: flex;
  flex-direction: column;
  margin-left: calc(25vw + 6px);
  padding-right: 16px;
  .project__title{
    width: 100%;
    position: relative;
    h2{
      font-family: var(--editor);
      font-size: 45px;
      color: var(--black);
      position: relative;
      padding-bottom: 4px;
      white-space: nowrap;
      height: 52px;
      min-width: 335px;
      .title {
        // position: absolute;
        // z-index: 100;
        // top: 0;
        // left: 0;
        // width: 100%;
        // height: 100%;
        // background: var(--white);
        // overflow: hidden;
      }
    }
      
    .title__sub {
      height: 16px;
      width: 125px;
      font-family: var(--conduitITC);
      color: var(--primary);
      font-size: 1.4rem;
      font-weight: 600;
      white-space: nowrap;
      text-transform: uppercase;
      margin-top: 2px;
    }
  }
  .project__infos{
    margin-top: 60px;
    padding: 0 16px;
    .infos__list{
      list-style: none;
      display: flex;
      flex-direction: row;
      li{
        margin-right: 24px;
        .list__value {
          width: 35px;
        }
        &:nth-child(2) {
          width: 130px;
          .list__value {
            width: 130px;
          }
        }
      }
      .list__title{
        font-family: var(--DIN);
        font-size: 1.4rem;
        color: var(--black);
        font-weight: 600;
        text-transform: uppercase;
      }
      .list__value{
        height: 16px;
        margin-top: 3px;
        font-family: var(--conduitITC);
        font-size: 1.6rem;
        color: var(--grey);
        font-weight: 400;
        position: relative;
      }
    }
    .description{
      margin: 20px 0;
      width: 100%;
      height: 66px;
      font-family: var(--conduitITC);
      font-size: 1.8rem;
      color: var(--grey);
      font-weight: 400;
      position: relative;
      span {
        line-height: 22px;
      }
    }
    a{
      display: inline-block;
      padding-bottom: 3px;
      font-size: 1.6rem;
      font-family: var(--conduitITC);
      font-weight: 600;
      color: var(--black);
      position: relative;
      text-decoration: none;
      text-transform: uppercase;
      &::after{
        content: "";
        position: absolute;
        bottom: 0px;
        left: 0;
        width: 100%;
        height: 2px;
        background: var(--primary);
        transform-origin: 0% 50%;
        transform: scaleX(.3);
        transition: transform .2s var(--easing);    
      }
      &:hover {
        &::after{
          transform: scaleX(1);
        }
      }
    }
  }
}
.project__image{
  width: calc(50vw - 1px);
  height: 400px;
  margin-left: auto;
  margin-right: 0;
  flex-shrink: 0;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  .image-transition {
    position: absolute;
    z-index: 110;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--primary);
    transform: scaleX(0);
    // &::before {
    //   content: "";
    //   position: absolute;
    //   z-index: 1;
    //   top: 0;
    //   right: 15%;
    //   width: 100%;
    //   height: 100%;
    //   background: var(--primary);
    // }
  }
  .img{
    position: absolute;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center center;
  }
}

#project {
  /**
  * Project
  */
  .project-enter-active{
    transition: opacity .1s var(--easing);
  }
  .project-leave-active{
    transition: opacity .5s .5s var(--easing);
  }
  .project-enter, .project-leave-to{
    opacity: 0;
  }


  /**
  * Title
  */

  .title-overlay-enter-active{
    animation: title-overlay .9s var(--easing) forwards;
  }
  @keyframes title-overlay{
    0%{
      transform: scaleX(0);
      transform-origin: 0% 50%;
    }
    49.99%{
      transform-origin: 0% 50%;
    }
    50%{
      transform: scaleX(1);
    }
    50.01%{
      transform-origin: 100% 50%;
    }
    100%{
      transform-origin: 100% 50%;    
      transform: scaleX(0)
    }
  }

  /**
  * Image
  */

  .image-overlay-enter-active{
    animation: image-overlay .9s var(--easing) forwards;
  }
  @keyframes image-overlay{
    0%{
      transform: scaleX(0);
      transform-origin: 0% 50%;
    }
    49.99%{
      transform-origin: 0% 50%;
    }
    50%{
      transform: scaleX(1);
    }
    50.01%{
      transform-origin: 100% 50%;
    }
    100%{
      transform-origin: 100% 50%;    
      transform: scaleX(0)
    }
  }

  .width-enter-active{
    transition: width .5s var(--easing);
    z-index: 10;
  }
  .width-enter {
    width: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Project.vue